import React from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import {InputWithIcon} from '../../../../../../itrust_common/components/form';
import { required } from '../../../../../../itrust_common/components/form/FormValidations';

let PupillaryDistance = props => {
  const { member, templates } = props;
  const pdConfig = templates?.find(t => t.category === 'orders')?.configuration?.eyeglass?.pupilary_distance;
  const getTitle = (baseTitle, fieldName) => {
    if (pdConfig?.[fieldName]?.is_required) {
      return <span>{baseTitle} <span className="text-danger">*</span></span>;
    }
    return baseTitle;
  };

  return (
    <div className="row mx-0 bg-light">
      <div className="col-12 p-5">
        <h6>Pupillary Distance</h6>
      </div>
      <div className="col-4 mb-5">
        <span>Distance</span>
      </div>
      <div className="col-4">
        <span>Intermediate</span>
      </div>
      <div className="col-4">
        <span>Near</span>
      </div>
      <Field name={`${member}[pupillary_distance][od_distance]`} component={InputWithIcon} title={getTitle('OD', 'od_distance')} className="form-control" wrapperClasses="col-4 form-group" />
      <Field name={`${member}[pupillary_distance][od_intermediate]`} component={InputWithIcon} title={getTitle('OD', 'od_intermediate')} className="form-control" wrapperClasses="col-4 form-group" />
      <Field name={`${member}[pupillary_distance][od_near]`} component={InputWithIcon} title={getTitle('OD', 'od_near')} className="form-control" wrapperClasses="col-4 form-group" />
      <Field name={`${member}[pupillary_distance][os_distance]`} component={InputWithIcon} title={getTitle('OS', 'os_distance')} className="form-control" wrapperClasses="col-4 form-group" />
      <Field name={`${member}[pupillary_distance][os_intermediate]`} component={InputWithIcon} title={getTitle('OS', 'os_intermediate')} className="form-control" wrapperClasses="col-4 form-group" />
      <Field name={`${member}[pupillary_distance][os_near]`} component={InputWithIcon} title={getTitle('OS', 'os_near')} className="form-control" wrapperClasses="col-4 form-group" />
      <Field name={`${member}[pupillary_distance][ou_distance]`} component={InputWithIcon} title={getTitle('OU', 'ou_distance')} className="form-control" wrapperClasses="col-4 form-group" />
      <Field name={`${member}[pupillary_distance][ou_intermediate]`} component={InputWithIcon} title={getTitle('OU', 'ou_intermediate')} className="form-control" wrapperClasses="col-4 form-group" />
      <Field name={`${member}[pupillary_distance][ou_near]`} component={InputWithIcon} title={getTitle('OU', 'ou_near')} className="form-control" wrapperClasses="col-4 form-group" />
    </div>
  )
}

const mapStateToProps = state => {
  return {
    templates: state.setting?.template?.templates || [],
  }
}

export default connect(mapStateToProps)(PupillaryDistance);